import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';
import Cta from '../../atoms/cta/cta';

import './static-links-container.scss';

export interface IStaticLinksContainer extends IComponent {
  links: { text: string; link: string }[];
}

const classNames = () =>
  makeClassNames({
    staticLinksContainer: 'static-links-container',
  });

const cn = classNames();

const StaticLinksContainer = ({ links }: IStaticLinksContainer) => {
  return (
    <div className={cn.staticLinksContainer}>
      {links
        ?.filter((l) => Boolean(l))
        ?.map(({ text, link }) => (
          <Cta key={text} href={link} iconPosition="right">
            {text}
          </Cta>
        ))}
    </div>
  );
};

export default StaticLinksContainer;
